"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditFindingRecord = void 0;
// Canonical securitydb 7763fcd, SSC-234; immutable original custody scope.
const zod_1 = require("zod");
const weight_1 = require("./weight");
const text = zod_1.z.string().min(1).max(64);
const correction = zod_1.z
    .object({
    itemKey: text,
    action: zod_1.z.enum(['added', 'removed', 'replaced', 'quantity_changed']),
    quantityBefore: zod_1.z.number().finite().nonnegative(),
    quantityAfter: zod_1.z.number().finite().nonnegative(),
    // Terminal-reported before/after sale-line totals, not estimated prevented loss.
    valueBeforeMinor: zod_1.z.number().int().nonnegative().safe(),
    valueAfterMinor: zod_1.z.number().int().nonnegative().safe(),
    currency: zod_1.z.string().regex(/^[A-Z]{3}$/),
    priceEvidence: zod_1.z.enum(['sale_line', 'confirmed_receipt']),
})
    .strict();
/** Immutable attendant outcome, distinct from a weighing's audited marker. */
exports.AuditFindingRecord = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(1),
    originScope: weight_1.WeightSampleOriginScope.optional(),
    clientUuid: zod_1.z.string().uuid(),
    auditId: zod_1.z.string().uuid(),
    weighingId: zod_1.z.string().min(1).max(64).optional(),
    saleId: text.optional(),
    lineId: text.optional(),
    occurredAt: zod_1.z.string().datetime({ offset: true }),
    attendantId: text.regex(/\S/),
    selectionReason: zod_1.z.enum(['risk', 'random', 'unknown_weight', 'voluntary', 'intervention']),
    status: zod_1.z.enum(['completed', 'cancelled']),
    finding: zod_1.z.enum([
        'correct_basket',
        'substitution',
        'unscanned_item',
        'quantity_mismatch',
        'inconclusive',
    ]),
    mode: zod_1.z.enum(['normal', 'learning', 'test']),
    corrections: zod_1.z.array(correction).max(100),
})
    .strict()
    .superRefine((r, ctx) => {
    if ((r.status === 'cancelled' ||
        r.finding === 'inconclusive' ||
        r.finding === 'correct_basket') &&
        r.corrections.length) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['corrections'],
            message: 'Corrections require a completed confirmed finding',
        });
    }
    if (r.status === 'cancelled' && r.finding !== 'inconclusive') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['finding'],
            message: 'Cancelled audits are inconclusive',
        });
    }
    if (r.corrections.length && !r.saleId) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['saleId'],
            message: 'Verified corrections require a sale reference',
        });
    }
});
//# sourceMappingURL=audit-finding.js.map